import {AppCategory} from '@web-catalog/types';

import {ROUTES} from '@web-catalog/routes';

import {CategoryString} from '@web-catalog/ui-kit/CategoryString';

import {useCategoriesAnalytics} from '@web-catalog/utils/analytics/useCategoriesAnalytics';

import styles from './CategoriesList.module.scss';
import {CategoriesListSkeleton} from './parts';

type Props = {
  categories: Array<AppCategory>;
  activeCategory?: string | Array<string>;
  isGamesPage?: boolean;
  colorizeIcons?: boolean;
};

export const CategoriesList: React.FC<Props> = ({
  categories,
  activeCategory,
  isGamesPage = false,
  colorizeIcons = false,
}) => {
  const pagesRoute = isGamesPage ? ROUTES.games.page : ROUTES.root.page;
  const {
    logGameCategorySelect,
    logAppCategorySelect,
    logAllAppsClick,
    logAllGamesClick,
  } = useCategoriesAnalytics('menu');

  const onClickCategory = (appCategoryName: string) => {
    const alreadyActive = Array.isArray(activeCategory)
      ? activeCategory.includes(appCategoryName)
      : appCategoryName === activeCategory;

    if (isGamesPage) {
      logGameCategorySelect(appCategoryName, alreadyActive);
    } else {
      logAppCategorySelect(appCategoryName, alreadyActive);
    }
  };

  const onClickAllCategories = () => {
    if (isGamesPage) {
      logAllGamesClick(!activeCategory);
    } else {
      logAllAppsClick(!activeCategory);
    }
  };

  const activeCategories = categories.filter((cat) => cat.appCount > 0);
  const allCategoryIcon = isGamesPage ? 'games' : 'apps';
  const allCategoryName = isGamesPage ? 'Все игры' : 'Все приложения';

  return (
    <ul className={styles.list} data-testid="categories">
      {!!activeCategories.length && (
        <li key={allCategoryName}>
          <CategoryString
            appsRoute={pagesRoute()}
            icon={allCategoryIcon}
            categoryName={allCategoryName}
            category={''}
            isActive={!activeCategory}
            onClickCategory={onClickAllCategories}
          />
        </li>
      )}

      {activeCategories.length ? (
        activeCategories.map(({category, iconUrl, categoryName, iconColor}) => {
          return (
            <li key={category}>
              <CategoryString
                appsRoute={pagesRoute({category: category.toLowerCase()})}
                icon={iconUrl}
                categoryName={categoryName}
                category={category}
                isActive={category === activeCategory}
                onClickCategory={onClickCategory}
                iconColor={colorizeIcons ? iconColor : undefined}
              />
            </li>
          );
        })
      ) : (
        <CategoriesListSkeleton />
      )}
    </ul>
  );
};
